// invoiceReducer.js

import {
  FETCH_INVOICES_REQUEST,
  FETCH_INVOICES_SUCCESS,
  FETCH_INVOICES_FAILURE,
  CREATE_INVOICE_REQUEST,
  CREATE_INVOICE_SUCCESS,
  CREATE_INVOICE_FAILURE,
  INVOICE_DETAIL_REQUEST,
  INVOICE_DETAIL_SUCCESS,
  INVOICE_DETAIL_FAILURE,
  UPDATE_INVOICE_REQUEST,
  UPDATE_INVOICE_SUCCESS,
  UPDATE_INVOICE_FAILURE,
  DELETE_INVOICE_REQUEST,
  DELETE_INVOICE_SUCCESS,
  DELETE_INVOICE_FAILURE,
} from "../Actions/Actions";

const initialState = {
  isLoading: false,
  invoices: [],
  selectedInvoice: null,
  error: null,
  createLoading: false,
  updateLoading: false,
  deleteLoading: false,
  lastDeleteMessage: null,
};

const invoiceReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    // Fetch invoices
    case FETCH_INVOICES_REQUEST:
      return { ...state, isLoading: true, error: null };
    case FETCH_INVOICES_SUCCESS:
      return { ...state, isLoading: false, invoices: payload };
    case FETCH_INVOICES_FAILURE:
      return { ...state, isLoading: false, error: payload };

    // Create invoice
    case CREATE_INVOICE_REQUEST:
      return { ...state, createLoading: true, error: null };
    case CREATE_INVOICE_SUCCESS:
      return {
        ...state,
        createLoading: false,
        invoices: [...state.invoices, payload],
      };
    case CREATE_INVOICE_FAILURE:
      return { ...state, createLoading: false, error: payload };

    // Invoice detail
    case INVOICE_DETAIL_REQUEST:
      return { ...state, isLoading: true, error: null };
    case INVOICE_DETAIL_SUCCESS:
      return { ...state, isLoading: false, selectedInvoice: payload };
    case INVOICE_DETAIL_FAILURE:
      return { ...state, isLoading: false, error: payload };

    // Update invoice
    case UPDATE_INVOICE_REQUEST:
      return { ...state, updateLoading: true, error: null };
    case UPDATE_INVOICE_SUCCESS:
      return {
        ...state,
        updateLoading: false,
        invoices: state.invoices.map((invoice) => {
          const currentId = invoice.id ?? invoice.invoice_id;
          const updatedId = payload.id ?? payload.invoice_id;
          return String(currentId) === String(updatedId) ? payload : invoice;
        }),
        selectedInvoice: payload,
      };
    case UPDATE_INVOICE_FAILURE:
      return { ...state, updateLoading: false, error: payload };

    // Delete invoice
    case DELETE_INVOICE_REQUEST:
      return { ...state, deleteLoading: true, error: null };
    case DELETE_INVOICE_SUCCESS:
      return {
        ...state,
        deleteLoading: false,
        invoices: state.invoices.filter((invoice) => {
          const currentId = invoice.id ?? invoice.invoice_id;
          const deletedId = typeof payload === 'object' ? payload.invoice_id : payload;
          return String(currentId) !== String(deletedId);
        }),
        lastDeleteMessage: typeof payload === 'object' ? payload.message : null,
      };
    case DELETE_INVOICE_FAILURE:
      return { ...state, deleteLoading: false, error: payload };

    default:
      return state;
  }
};

export default invoiceReducer;